module.exports = __webpack_public_path__ + "img/xihuan.f9b0065d.png";